import React from 'react';
import { Button, Box, Modal, SpaceBetween, Table } from '@amzn/awsui-components-react';
import { FieldChanges } from 'src/models/AuditEvents';

interface FieldChangesModalProps {
  visible: boolean;
  onDismiss: () => void;
  lastUpdatedBy: string;
  lastUpdatedDateTime: string;
  changes: FieldChanges[] | null;
  error: string | null;
}

export default function FieldChangesModal({
  visible,
  onDismiss,
  lastUpdatedBy,
  lastUpdatedDateTime,
  changes,
  error,
}: FieldChangesModalProps) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={`Changes on ${new Date(lastUpdatedDateTime).toLocaleString()} by ${lastUpdatedBy}`}
      footer={
        <Box float="right">
          <Button variant="primary" onClick={onDismiss}>
            Close
          </Button>
        </Box>
      }
      size="large"
    >
      <SpaceBetween size="m">
        {error && <Box textAlign="center">Error loading changes: {error}</Box>}
        {changes ? (
          <Table
            columnDefinitions={[
              {
                id: 'field',
                header: 'Field',
                cell: (item) => item.key || '-',
                width: 200,
              },
              {
                id: 'oldValue',
                header: 'Old Value',
                cell: (item) => (String(item.value.oldValue) === null ? null : item.value.oldValue),
              },
              {
                id: 'newValue',
                header: 'New Value',
                cell: (item) => (String(item.value.newValue) === null ? null : item.value.newValue),
              },
            ]}
            items={changes}
            loadingText="Loading changes..."
            empty={
              <Box textAlign="center" color="inherit">
                No changes detected
              </Box>
            }
            trackBy="key"
          />
        ) : (
          <Box textAlign="center">No change details available</Box>
        )}
      </SpaceBetween>
    </Modal>
  );
}
